import React, { useContext, useEffect, useState } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import { appContext } from "../../AarmaContext";
import axios from "axios";
import Pagination from "../../Common/Pagination";

function ReferralReward() {
  const { account, settings, copyaddress, formatAddress } = useContext(appContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);


  const getData = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "referralreward",
        submethod: "getbyid",
        address: account,
        page: currentPage,
        pageSize: pageSize,
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));

      });
  };
  
  useEffect(() => {
    getData();
  }, [account, pages, pageSize, currentPage]);
  return (
    <>
      <Header />
      <section className="discover_web3 pools_tables pt-120 pb-120 earn_crypto vh-100">
        <h1 className="d-flex justify-content-center">Referral Reward</h1>
        <div className="container d-flex align-items-center pt-5 ">
          <div className="col-12 pt-5">
            <div className="apex_section__tablearea br2 rounded-20 bg1-color overflow-auto mt-5 mt-md-6">
              <div className="apex_section__tablechart p-5 p-md-6 d-flex gap-4 align-items-center justify-content-between bg_blur">
                <table>
                  <tbody>
                    <tr className="text-center ">
                      <th className="fs-ten">#</th>
                      <th className="fs-ten">Rrom address</th>
                      <th className="fs-ten">To address</th>
                      <th className="fs-ten">Amount</th>
                      <th className="fs-ten">Referral Reward</th>
                      <th className="fs-ten">Referral Reward Persentage</th>
                    </tr>
                    {data.map((item, index) => {
                      return (
                        <tr className="text-center tablehover">
                          <td>{item.id}</td>
                          <td>{formatAddress(item.from_address)}</td>
                          <td>{formatAddress(item.to_address)}</td>
                          <td>{item.amount}</td>
                          <td>{item.referral_rewardd}</td>
                          <td>{item.referral_reward_persentage}{'%'}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pages={pages}
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ReferralReward;
